/* eslint-disable prettier/prettier */
import styled from 'styled-components';

interface Iprops {
  theme: string;
}

export const ContainerCard = styled.div<Iprops>`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 80px);
  padding: 2rem;

  .disabled {
    display: none;
  }

  a {
    ${({ theme }: Iprops): string =>
      theme === 'light' ? 'background: #fff' : 'background: #1F2029'};

    transition: all 0.3s ease;
    width: 100%;
    height: 160px;
    padding: 24px 16px;
    display: flex;
    border-radius: 12px;
    cursor: pointer;
    text-decoration: none;
    border: 1px solid transparent;

    ${({ theme }: Iprops): string =>
      theme === 'light'
        ? 'border-color: #e2e8f0; box-shadow: 0 1px 3px rgba(0,0,0,0.08);'
        : 'border-color: #2d3748; box-shadow: 0 1px 3px rgba(0,0,0,0.2);'};

    :hover {
      transform: translateY(-4px);
      ${({ theme }: Iprops): string =>
        theme === 'light'
          ? 'box-shadow: 0 8px 25px rgba(0,0,0,0.1); border-color: #cbd5e1;'
          : 'box-shadow: 0 8px 25px rgba(0,0,0,0.4); border-color: #4a5568;'};
    }

    :active {
      transform: translateY(-1px);
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  gap: 12px;

  .pacientes {
    width: 3.5rem;
    height: 3.5rem;
    object-fit: contain;
  }

  .revoq {
    width: 3.5rem;
    height: 3.5rem;
    object-fit: contain;
  }

  .lucro {
    width: 3.5rem;
    height: 3.5rem;
    object-fit: contain;
  }

  img {
    width: 3.5rem;
    height: 3.5rem;
    object-fit: contain;
  }

  strong {
    margin-top: 10px;
  }
`;
